export default class LearningCommunityListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, $filter, Requests, $sessionStorage) {
    var learningCommunityListVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    learningCommunityListVm.mainLabel = 'Comunidades de aprendizaje y práctica'
    learningCommunityListVm.gradCommunityClass = 'grad-1'
    learningCommunityListVm.communitiesList = []
    learningCommunityListVm.active = GlobalConfig.generals.active
    learningCommunityListVm.notActive = GlobalConfig.generals.notActive
    learningCommunityListVm.inReview = 0
    learningCommunityListVm.feedback = 0
    learningCommunityListVm.planningFinish = true
    learningCommunityListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    learningCommunityListVm.$sessionStorage = $sessionStorage

    const header = {
      teacherId: currentUser.teacherId,
      workplanId: currentUser.workplanId
    }
    learningCommunityListVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]


	// VARIABLES
    learningCommunityListVm.viewLoaded = true
    learningCommunityListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

	// METHODS
    learningCommunityListVm.updateView = updateView 
    learningCommunityListVm.confirmDeleteCommunity = confirmDeleteCommunity
    learningCommunityListVm.getGeneralsWorkplan = getGeneralsWorkplan
    learningCommunityListVm.validateSearch = validateSearch
    learningCommunityListVm.bitacora = bitacora

    function validateSearch() {
      return $filter('filter')(learningCommunityListVm.communitiesList, learningCommunityListVm.communityFilter)
    }
    
    activate()

    function activate () {
      let post = {
        teacherId: currentUser.teacherId
      }

      if(learningCommunityListVm.workPlanGeneralList != undefined){
        learningCommunityListVm.status = learningCommunityListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        learningCommunityListVm.stages = learningCommunityListVm.workPlanGeneralList.stages
        learningCommunityListVm.inReview = learningCommunityListVm.status.reviewed
        learningCommunityListVm.feedback = learningCommunityListVm.status.feedbackReviewed
        learningCommunityListVm.workplanTeacherId = learningCommunityListVm.status.workplanTeacherId
        isPlanning(learningCommunityListVm.status, learningCommunityListVm.stages)

        if(learningCommunityListVm.feedback && !learningCommunityListVm.planningFinish){
          getDataFormCommunitiesReject()
        }else{
          getDataFormCommunities()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(learningCommunityListVm.feedback && !learningCommunityListVm.planningFinish){
            getDataFormCommunitiesReject()
          }else{
            getDataFormCommunities()
          }
        })
      }
    }
    
    function getDataFormCommunities() {
      // List Service Communities
      WorkPlanSrv.getDataFormCommunities.get(header).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          //console.log(dataReturn)
          learningCommunityListVm.dataCommunitiesList = dataReturn
          console.log("learningCommunityListVm.dataCommunitiesList")
          console.log(learningCommunityListVm.dataCommunitiesList)
          learningCommunityListVm.communitiesList = learningCommunityListVm.dataCommunitiesList.communities
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data)
      })
    }  

    function getDataFormCommunitiesReject() {
      // List Service Communities
      WorkPlanSrv.getDataFormCommunitiesReject.get(header).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          //console.log(dataReturn)
          learningCommunityListVm.dataCommunitiesList = dataReturn
          learningCommunityListVm.communitiesList = learningCommunityListVm.dataCommunitiesList.communities
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data)
      })
    }  

    function updateView() {

      learningCommunityListVm.viewLoaded = false
      $timeout( () => {
        learningCommunityListVm.viewLoaded = true
      }, 1000)
    }

    function confirmDeleteCommunity (itemCommunity) { 
      let communityName = itemCommunity.listItemNameCommunity
      let communityId = itemCommunity.workplanTeacherActivityId

      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.communityName = communityName
          ctrlModalVM.communityId = communityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteCommunity = function () {
            let requestHeader = {workplanTeacherActivityId: ctrlModalVM.communityId }
            WorkPlanSrv.deleteDataFormCommunities.delete(requestHeader)
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeCommunityFromCaroussel(itemCommunity)
                showDeletedCommunitySuccessfully(ctrlModalVM.communityName)
                WorkPlanIndicatorSrv.setVariable(true)
                itemCommunity.notShow = true
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteCommunityModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedCommunitySuccessfully(communityName){

      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : communityName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })

    }

    function removeCommunityFromCaroussel(community){
      for(var i in learningCommunityListVm.communitiesList){
        if(learningCommunityListVm.communitiesList[i].workplanTeacherActivityId === community.workplanTeacherActivityId){
          learningCommunityListVm.communitiesList.splice(i,1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          learningCommunityListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          learningCommunityListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          learningCommunityListVm.stages = dataReturn.data.stages
          learningCommunityListVm.inReview = learningCommunityListVm.status.reviewed
          learningCommunityListVm.feedback = learningCommunityListVm.status.feedbackReviewed
          learningCommunityListVm.workplanTeacherId = learningCommunityListVm.status.workplanTeacherId
          isPlanning(learningCommunityListVm.status, learningCommunityListVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      learningCommunityListVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          learningCommunityListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == learningCommunityListVm.active){        
          learningCommunityListVm.planningFinish = true
          if (learningCommunityListVm.startDateReview < learningCommunityListVm.currentDate || status.reviewedFinish == learningCommunityListVm.active){
            learningCommunityListVm.planningFinish = true
          }else if (status.reviewedReject == learningCommunityListVm.active){
            learningCommunityListVm.planningFinish = false
          }
        } else {
            learningCommunityListVm.planningFinish = false
        }
      }else{
        learningCommunityListVm.planningFinish = true
      }

      $scope.classPlanning = (learningCommunityListVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.community,
        workplanTeacherId: learningCommunityListVm.workplanTeacherId
      }
      entries.title = 'Comunidades de aprendizaje y práctica'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}

LearningCommunityListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', '$filter', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/learningAndPracticeCommunities/list/learningCommunityListCtrl.js